// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-list {
  min-height: 50vh;
  border-radius: 14px;
  overflow: hidden;
  display: block;
  margin-bottom: 5vh;
  background: rgba(128, 128, 128, 0.0901960784);
  height: 75%;
  overflow-y: scroll;
  padding: 15px;
}

.example-box {
  padding: 10px 10px 5px 10px;
  border: solid 1px #ccc;
  color: rgba(236, 236, 236, 0.87);
  border-radius: 10px;
  cursor: move;
  margin-bottom: 5px;
  font-size: 14px;
}

.mat-mdc-menu-item {
  justify-content: flex-end;
  display: flex;
  align-content: center;
  margin-top: 4%;
  padding: 7px;
  height: 2.5%;
  transform: rotate(180deg) !important;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.btn-add {
  background-color: #f1f0f3;
}

.btn-add:hover {
  background-color: rgb(206, 206, 206);
}

.column-header {
  border: 1px solid rgb(207, 207, 207);
  border-radius: 14px;
  margin-bottom: 6px;
  background-color: #FCFAFF;
}
.column-header .header-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-content .active::ng-deep {
  background-color: #104A64;
  border-color: #104A64;
  color: white;
}

.mat-mdc-raised-button::ng-deep {
  box-shadow: none;
}

.parent-color {
  position: relative;
}
.parent-color #color {
  margin-top: 4px;
  -webkit-appearance: none;
  padding: 0;
  border: none;
  border-radius: 10px;
  width: 19px;
  height: 18px;
}
.parent-color #color::-webkit-color-swatch {
  border: none;
  border-radius: 10px;
  padding: 0;
}
.parent-color #color::-webkit-color-swatch-wrapper {
  border: none;
  border-radius: 10px;
  padding: 0;
}

.empty {
  height: 100vh;
  opacity: 0.56;
  font-size: 32px;
  line-height: 1.33;
  letter-spacing: -1px;
  color: black;
  padding: auto;
  text-align: center;
}

.page-title {
  margin-top: 25px;
  margin-bottom: 25px;
  color: #104a64;
  font-size: 2.3rem;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center;
  align-items: center;
  flex: 1 1 0%;
}

.toolbar {
  display: flex;
  width: 100%;
  height: 4%;
}

.file-manager-open {
  display: flex;
  flex-flow: column;
  flex: 0 0 25%;
  min-width: 382px;
  max-width: 500px;
  position: relative;
  background: var(--chat-sidemenu-bg-color);
  height: 107%;
  border-top-left-radius: var(--chat-container-border-radius);
  border-bottom-left-radius: var(--chat-container-border-radius);
  border-right: 1px solid #e1e4e8;
}

.file-manager-close {
  display: none;
  width: 346%;
  height: 100vh;
  border-right-width: 1px solid;
  margin-right: 13px;
}

/* Style The Dropdown Button */
.dropbtn {
  background-color: #4CAF50;
  color: white;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown > button {
  background-color: #104A64;
  color: white;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  border: 1px solid;
  background-color: #f9f9f9;
  min-width: 160px;
  z-index: 3;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  font-size: 17px;
  padding: 12px 12px;
  text-decoration: none;
  display: block;
}

.column {
  margin: 0px 15px;
  width: -webkit-fill-available;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #104A64;
  color: white;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

.img_kanban {
  width: 90%;
  height: 80%;
}

.title-size {
  font-size: 24px;
}

@media (max-width: 1486px) {
  .file-manager-open {
    display: flex;
    flex-flow: column;
    flex: 0 0 25%;
    min-width: 250px;
    max-width: 250px;
    width: 250px;
    position: relative;
    background: var(--chat-sidemenu-bg-color);
    height: 100vh;
    border-top-left-radius: var(--chat-container-border-radius);
    border-bottom-left-radius: var(--chat-container-border-radius);
    border-right: 1px solid #e1e4e8;
  }
}
.columns-container {
  height: 70vh;
}
.columns-container > div {
  flex-wrap: nowrap;
  width: 95%;
  overflow-x: scroll;
  height: 100%;
}
.columns-container > div ::-webkit-scrollbar {
  height: 4px;
}

.mat-h2 {
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-delete mat-icon {
  font-size: 20px;
}

@media (max-width: 1238px) {
  .task {
    width: 10%;
  }
}
::ng-deep .mat-dialog-content {
  color: black;
}

::ng-deep .mat-mdc-dialog-surface {
  width: 390px;
  height: 290px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-top: 20px;
}

.dialog-large {
  width: 500px;
  height: 300px;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/board/board/board.component.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EAEA,kBAAA;EACA,6CAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAFJ;;AAKE;EACE,2BAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAFJ;;AAIE;EACE,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACC,oCAAA;AADL;;AAIE;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AADJ;;AAME;EACE,UAAA;AAHJ;;AAME;EACE,sDAAA;AAHJ;;AAME;EACE,YAAA;AAHJ;;AAME;EACE,sDAAA;AAHJ;;AAME;EACE,yBAAA;AAHJ;;AAME;EACE,oCAAA;AAHJ;;AAME;EACE,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAHJ;AAIM;EACE,gBAAA;EACA,uBAAA;AAFR;;AAOI;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AAJN;;AASA;EACE,gBAAA;AANF;;AAUE;EACE,kBAAA;AAPJ;AASI;EACE,eAAA;EACA,wBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAPN;AASI;EACE,YAAA;EACA,mBAAA;EACA,UAAA;AAPN;AASI;EACE,YAAA;EACA,mBAAA;EACA,UAAA;AAPN;;AAUE;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EAEA,aAAA;EACA,kBAAA;AARJ;;AAWE;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AARJ;;AAUE;EACE,aAAA;EACA,WAAA;EACA,UAAA;AAPJ;;AAUE;EAOI,aAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACF,yCAAA;EACE,YAAA;EACA,2DAAA;EACA,8DAAA;EACF,+BAAA;AAbJ;;AAgBE;EAEE,aAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AAdJ;;AAiBE,8BAAA;AACF;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAdF;;AAiBA,kEAAA;AACA;EACE,kBAAA;EACA,qBAAA;AAdF;AAeI;EACE,yBAAA;EACA,YAAA;AAbN;;AAiBA,yCAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;AAdF;;AAiBA,8BAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AAdF;;AAiBA;EACI,gBAAA;EAEA,6BAAA;AAdJ;;AAiBA,4CAAA;AACA;EACE,yBAAA;EACA,YAAA;AAdF;;AAiBA,oCAAA;AACA;EACE,cAAA;AAdF;;AAiBA,0FAAA;AACA;EACE,yBAAA;AAdF;;AAsBE;EACE,UAAA;EACA,WAAA;AAnBJ;;AAqBE;EACE,eAAA;AAlBJ;;AAqBE;EACE;IAOI,aAAA;IACA,iBAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;IACF,yCAAA;IACE,aAAA;IACA,2DAAA;IACA,8DAAA;IACF,+BAAA;EAxBJ;AACF;AA4BE;EACE,YAAA;AA1BJ;AA4BI;EAEE,iBAAA;EACA,UAAA;EACF,kBAAA;EACA,YAAA;AA3BJ;AA4BI;EACE,WAAA;AA1BN;;AA8BE;EACE,gBAAA;EACA,uBAAA;AA3BJ;;AA+BI;EACE,eAAA;AA5BN;;AA+BE;EACE;IACE,UAAA;EA5BJ;AACF;AA8BE;EACA,YAAA;AA5BF;;AA8BA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AA3BJ;;AA6BA;EACE,YAAA;EACA,aAAA;AA1BF;;AA4BA;EACE,kCAAA;AAzBF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.example-list {\r\n    min-height: 50vh;\r\n    border-radius: 14px;\r\n    overflow: hidden;\r\n    display: block;\r\n    // height: 340%;\r\n    margin-bottom:5vh;\r\n    background: #80808017;\r\n    height: 75%;\r\n    overflow-y: scroll;\r\n    padding: 15px;\r\n    }\r\n  \r\n  .example-box {\r\n    padding: 10px 10px 5px 10px;\r\n    border: solid 1px #ccc;\r\n    color: rgba(236, 236, 236, 0.87);\r\n    border-radius: 10px;\r\n    cursor: move;\r\n    margin-bottom: 5px;\r\n    font-size: 14px;\r\n  }\r\n  .mat-mdc-menu-item {\r\n    justify-content: flex-end;\r\n    display: flex;\r\n    align-content: center;\r\n    margin-top: 4%;\r\n    padding: 7px;\r\n    height:2.5%;\r\n     transform: rotate(180deg)!important;\r\n  }\r\n  \r\n  .cdk-drag-preview {\r\n    box-sizing: border-box;\r\n    border-radius: 4px;\r\n    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\r\n                0 8px 10px 1px rgba(0, 0, 0, 0.14),\r\n                0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n  }\r\n  \r\n  .cdk-drag-placeholder {\r\n    opacity: 0;\r\n  }\r\n  \r\n  .cdk-drag-animating {\r\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n  }\r\n  \r\n  .example-box:last-child {\r\n    border: none;\r\n  }\r\n  \r\n  .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\r\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n  }\r\n  \r\n  .btn-add {\r\n    background-color: #f1f0f3;\r\n  }\r\n\r\n  .btn-add:hover{\r\n    background-color:rgb(206, 206, 206)\r\n  }\r\n  \r\n  .column-header {\r\n    border: 1px solid rgb(207, 207, 207);\r\n    border-radius: 14px;\r\n    margin-bottom: 6px;\r\n    background-color: #FCFAFF;\r\n      .header-label {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n\r\n  }\r\n  .dropdown-content {\r\n    .active::ng-deep{\r\n      background-color: #104A64;\r\n      border-color: #104A64;\r\n      color:white\r\n    }\r\n      \r\n  }\r\n\r\n.mat-mdc-raised-button::ng-deep{\r\n  box-shadow: none\r\n}\r\n\r\n\r\n  .parent-color {\r\n    position: relative;\r\n  \r\n    #color {\r\n      margin-top: 4px;\r\n      -webkit-appearance: none;\r\n      padding: 0;\r\n      border: none;\r\n      border-radius: 10px;\r\n      width: 19px;\r\n      height: 18px;\r\n    }\r\n    #color::-webkit-color-swatch {\r\n      border: none;\r\n      border-radius: 10px;\r\n      padding: 0;\r\n    }\r\n    #color::-webkit-color-swatch-wrapper {\r\n      border: none;\r\n      border-radius: 10px;\r\n      padding: 0;\r\n    }\r\n  }\r\n  .empty {\r\n    height: 100vh;\r\n    opacity: 0.56;\r\n    font-size: 32px;\r\n    line-height: 1.33;\r\n    letter-spacing: -1px;\r\n    color: black;\r\n    // margin: 150px auto;\r\n    padding: auto;\r\n    text-align: center;\r\n  }\r\n\r\n  .page-title{\r\n    margin-top: 25px;\r\n    margin-bottom: 25px;\r\n    color: #104a64;\r\n    font-size: 2.3rem;\r\n    flex-direction: row;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    place-content: center;\r\n    align-items: center;\r\n    flex: 1 1 0%;\r\n  }\r\n  .toolbar{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 4%;\r\n    }\r\n  \r\n  .file-manager-open{\r\n    // display: block;\r\n    // width: 30vh;\r\n    // height: 100vh; \r\n    // border-right-width: 1px solid;\r\n    // margin-right: 13px;\r\n    // background-color: $primary-color;\r\n      display: flex;\r\n      flex-flow: column;\r\n      flex: 0 0 25%;\r\n      min-width: 382px;\r\n      max-width: 500px;\r\n      position: relative;\r\n    background: var(--chat-sidemenu-bg-color);\r\n      height: 107%;\r\n      border-top-left-radius: var(--chat-container-border-radius);\r\n      border-bottom-left-radius: var(--chat-container-border-radius);\r\n    border-right: 1px solid #e1e4e8;\r\n  }\r\n  \r\n  .file-manager-close{\r\n  \r\n    display: none;\r\n    width: 346%;\r\n    height: 100vh; \r\n    border-right-width: 1px solid;\r\n    margin-right: 13px;\r\n  }\r\n  \r\n  /* Style The Dropdown Button */\r\n.dropbtn {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n  font-size: 16px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n/* The container <div> - needed to position the dropdown content */\r\n.dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n    > button {\r\n      background-color:#104A64;\r\n      color:white;\r\n    }\r\n}\r\n\r\n/* Dropdown Content (Hidden by Default) */\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  border: 1px solid;\r\n  background-color: #f9f9f9;\r\n  min-width: 160px;\r\n  z-index: 3;\r\n}\r\n\r\n/* Links inside the dropdown */\r\n.dropdown-content a {\r\n  color: black;\r\n  font-size: 17px;\r\n  padding: 12px 12px;\r\n  text-decoration: none;\r\n  display: block;\r\n}\r\n\r\n.column {\r\n    margin: 0px 15px;\r\n    width: -moz-available;\r\n    width: -webkit-fill-available;\r\n}\r\n\r\n/* Change color of dropdown links on hover */\r\n.dropdown-content a:hover {\r\n  background-color: #104A64;\r\n  color:white;\r\n}\r\n\r\n/* Show the dropdown menu on hover */\r\n.dropdown:hover .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n/* Change the background color of the dropdown button when the dropdown content is shown */\r\n.dropdown:hover .dropbtn {\r\n  background-color: #3e8e41;\r\n}\r\n\r\n  .kanban{\r\n    //width: 100%;\r\n  \r\n  }\r\n\r\n  .img_kanban{\r\n    width : 90%;\r\n    height : 80%\r\n  }\r\n  .title-size{\r\n    font-size: 24px\r\n  }\r\n\r\n  @media (max-width: 1486px) {\r\n    .file-manager-open{\r\n      // display: block;\r\n      // width: 30vh;\r\n      // height: 100vh; \r\n      // border-right-width: 1px solid;\r\n      // margin-right: 13px;\r\n      // background-color: $primary-color;\r\n        display: flex;\r\n        flex-flow: column;\r\n        flex: 0 0 25%;\r\n        min-width: 250px;\r\n        max-width: 250px;\r\n        width: 250px;\r\n        position: relative;\r\n      background: var(--chat-sidemenu-bg-color);\r\n        height: 100vh;\r\n        border-top-left-radius: var(--chat-container-border-radius);\r\n        border-bottom-left-radius: var(--chat-container-border-radius);\r\n      border-right: 1px solid #e1e4e8;\r\n    }\r\n\r\n    \r\n  }\r\n  .columns-container {\r\n    height: 70vh;\r\n    \r\n    > div {\r\n      //justify-content: space-around;\r\n      flex-wrap: nowrap;\r\n      width: 95%;\r\n    overflow-x: scroll;\r\n    height: 100%;\r\n    ::-webkit-scrollbar {\r\n      height: 4px;\r\n    }\r\n    }\r\n  }\r\n  .mat-h2 {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  .icon-delete {\r\n    mat-icon {\r\n      font-size: 20px;\r\n    }\r\n  }\r\n  @media (max-width: 1238px) {\r\n    .task{\r\n      width: 10%\r\n    }\r\n  }\r\n  ::ng-deep .mat-dialog-content {\r\n  color: black;\r\n}\r\n::ng-deep .mat-mdc-dialog-surface{\r\n    width: 390px;\r\n    height: 290px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    padding-bottom: 20px;\r\n    padding-top: 20px;\r\n}\r\n.dialog-large {\r\n  width: 500px;\r\n  height: 300px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
